import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-ui-modal',
  imports: [],
  template: `
    @if (isOpen()) {
    <div class="m-modal">
      <div class="m-modal__overlay" (click)="handleClose()"></div>
      <div class="m-modal__container">
        <div class="m-modal__header">
          <div class="m-modal__headerContent">
            <h3 class="m-modal__title">{{ title() }}</h3>
            @if (subtitle()) {
            <p class="m-modal__subtitle">{{ subtitle() }}</p>
            }
          </div>
          <button type="button" class="m-modal__closeBtn" (click)="handleClose()">✕</button>
        </div>
        <div class="m-modal__body">
          <ng-content />
        </div>
      </div>
    </div>
    }
  `,
  styleUrl: './ui-modal.component.scss',
})
export class UiModalComponent {
  isOpen = input.required<boolean>();
  title = input.required<string>();
  subtitle = input<string>();
  closed = output<void>();

  handleClose(): void {
    this.closed.emit();
  }
}
